export default defineNuxtPlugin(() => {
	const navigateToOld = (to: any, options: any = {}) => {
		const path = typeof to === 'string' ? to : to?.path || to?.name || '';

		if (path.startsWith('/pages/')) {
			if (import.meta.client) {
				return navigateTo(to, { external: true, ...options });
			}
			return;
		}
		return navigateTo(to, options);
	};
	const navigateToIframe = (to: any, options: any = {}) => {
		// 判断是否带有http开头，如果带有则直接返回
		let iframeUrl = '';
		if (to.startsWith('http')) {
			iframeUrl = to;
		} else {
			const pTh = to.startsWith('/') ? to : '/' + to;
			iframeUrl = import.meta.env.outIframeUrl + pTh;
		}
		return navigateTo('/iframePages?iframeUrl=' + encodeURIComponent(iframeUrl), { external: true, ...options });
	};

	return {
		provide: { navigateToOld, navigateToIframe },
	};
});
